import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MarketplaceManagerService } from 'src/app/services/marketplace-manager.service';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { TenantHomepageConfigurationComponent } from '../tenant-homepage-configuration/tenant-homepage-configuration.component';
import { BaseManageConfiguration } from '../base-manage-configuration';

@Component({
  selector: 'app-manage-customer-homepage',
  template: `
    <div class="hp-page">
      <div
        class="pagehead"
        style="display:flex;justify-content:space-between;align-items:flex-start"
      >
        <div>
          <h1>Customer homepage configuration</h1>
          <p>Set the custom homepage HTML shown to each consumer tenant.</p>
        </div>
        <button class="btn-primary" (click)="addHomepage()">
          <svg
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 5v14M5 12h14" />
          </svg>
          Homepage
        </button>
      </div>

      <div class="hpgrid">
        <div class="hp-card" *ngFor="let hpConf of configuredHomepages">
          <div class="hp-top">
            <span class="hp-ic">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M16 18l6-6-6-6M8 6l-6 6 6 6" />
              </svg>
            </span>
            <div>
              <div class="hp-lbl">Tenant name</div>
              <div class="hp-nm">{{ hpConf.tenant }}</div>
            </div>
          </div>
          <div class="hp-acts">
            <span
              class="iconbtn"
              matTooltip="Edit"
              (click)="updateHomepage(hpConf)"
            >
              <svg
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
              </svg>
            </span>
            <span
              class="iconbtn danger"
              matTooltip="Delete"
              (click)="deleteWebChat(hpConf.tenant)"
            >
              <svg
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M19 6v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6M10 11v6M14 11v6"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./manage-customer-homepage.component.scss'],
})
export class ManageCustomerHomepageComponent extends BaseManageConfiguration implements OnInit {
  configuredHomepages: any;

  constructor(
    dialog: MatDialog,
    marketplaceManagerServices: MarketplaceManagerService,
    sharedServices: SharedFeaturesService
  ) {
    super(dialog, marketplaceManagerServices, sharedServices);
  }

  ngOnInit(): void {
    this.refreshConfiguredHomepage();
  }

  refreshConfiguredHomepage(): void {
    this.marketplaceManagerServices.getConfiguredCustomHomepages().subscribe({
      next: (response: any) => {
        this.configuredHomepages = response;
      },
      error: (error: any) => {
        console.error('An error occurred', error);
      },
    });
  }

  addHomepage(): void {
    const deployForm = this.dialog.open(TenantHomepageConfigurationComponent, {
      disableClose: false,
      panelClass: 'homepage-config-dialog',
    });
    this.handleConfigureDialog(
      deployForm,
      (result) => this.marketplaceManagerServices.configureHomepage(result),
      () => this.refreshConfiguredHomepage()
    );
  }

  updateHomepage(homepageData: any): void {
    const deployForm = this.dialog.open(TenantHomepageConfigurationComponent, {
      data: homepageData,
      disableClose: false,
      panelClass: 'homepage-config-dialog',
    });
    this.handleConfigureDialog(
      deployForm,
      (result) => this.marketplaceManagerServices.configureHomepage(result),
      () => this.refreshConfiguredHomepage()
    );
  }

  deleteWebChat(name: string): void {
    this.handleDeleteConfirm(
      name,
      `Are you sure you want to delete '${name}' homepage ?`,
      (n) => this.marketplaceManagerServices.deleteConfiguredHomepage(n),
      () => this.refreshConfiguredHomepage()
    );
  }
}
